export default __webpack_public_path__ + "static/media/screen_heights.c031c080.png";